export default function Differentials() {
  return (
    <div
      id="differentials"
      className="lg:mx-6 my-12 lg:my-24 flex gap-6 flex-col"
    >
      {/* Title and description */}
      <div className="w-full mx-auto flex-center max-w-7xl">
        <div className="w-full px-6 lg:px-0 flex flex-col lg:flex-row mb-12 gap-6">
          <div className="flex-1 flex flex-col justify-between gap-6">
            <div className="inline-flex px-8 py-2 border-2 border-[#464646] text-[#464646] rounded-full font-semibold text-xs lg:text-sm self-center lg:self-start">
              Aproveite!
            </div>
            <h1 className="flex flex-col gap-1 text-3xl text-center lg:text-start lg:text-5xl lg:pr-24 font-extrabold leading-snug">
              <span className="text-bluecaixa">Não perca as ofertas</span>
              <span className="text-orangecaixa"> CAIXA Pré-Pagos</span>
            </h1>
          </div>
          <div className="flex-1 flex flex-col lg:pl-24 justify-center">
            <div className="text-[#525252] text-center lg:text-start w-full text-xl lg:text-2xl font-thin leading-relaxed">
              <p>O que você procura, com condições que fazem a diferença.</p>
              <p>Aproveite agora!</p>
            </div>
          </div>
        </div>

        {/* CARDS */}
        {/* <div className="flex flex-row lg:w-full lg:justify-between gap-4 px-6 lg:px-0 overflow-x-scroll lg:overflow-auto no-scrollbar">
          <div className="flex-shrink-0 min-w-[315px]">
            <DifferencialsCardStatic
              title="Sem filas"
              description="Peça já sua tagCAIXA e aproveite planos até sem mensalidade com Cartões de Crédito CAIXA elegíveis"
              img_src="/assets/differentials-imgs/banner1.png"
              href="https://ecommerce.caixaprepagos.com.br/?_gl=1*4519xw*_gcl_au*OTYwODU2NDIxLjE3NTYyMDkyMzM.*_ga*Mjc4OTUyMDk0LjE3NTYyMDkyMzM.*_ga_JC95Z392DC*czE3NTYyMDkyMzMkbzEkZzEkdDE3NTYyMDk0OTQkajYwJGwxJGgyODAzNjI1MDI.*_ga_SNXXFWQEJT*czE3NTYyMDkyMzMkbzEkZzAkdDE3NTYyMDkyNTAkajQzJGwwJGg2MjgyMjgwODU."
            />
          </div>
          <div className="flex-shrink-0 min-w-[315px]">
            <DifferencialsCardStatic
              title="CAIXA Pré-Pagos Marketplace"
              description="Com os cartões CAIXA Alimentação, Refeição e Multi, sua empresa pode ter acesso a uma plataforma de pontos exclusiva, para trocar por produtos e serviços relacionados a saúde e nutrição."
              img_src="/assets/differentials-imgs/banner2.png"
              href="https://marketplace.caixaprepagos.com.br/"
            />
          </div>
          <div className="flex-shrink-0 min-w-[315px]">
            <DifferencialsCardStatic
              title="Poupador vtCAIXA"
              description="Conheça a solução para compra e gestão de vale-transporte em todo o Brasil da CAIXA Pré-Pagos e economize até 20% na emissão de vale-transporte para seus colaboradores com a ferramenta Poupador!"
              img_src="/assets/differentials-imgs/banner3.png"
              href="/vtcaixa"
            />
          </div>
        </div> */}
      </div>
    </div>
  );
}
